const actions = {
  GET_ALL_USERS_FROM_MYMENU_REQUEST: "GET_ALL_USERS_FROM_MYMENU_REQUEST",
  GET_ALL_USERS_FROM_MYMENU_SUCCESS: "GET_ALL_USERS_FROM_MYMENU_SUCCESS",

  GET_ALL_DISCOUNTS_REQUEST: "GET_ALL_DISCOUNTS_REQUEST",
  GET_ALL_DISCOUNTS_SUCCESS: "GET_ALL_DISCOUNTS_SUCCESS",

  APPEND_DISCOUNTS_REQUEST: "APPEND_DISCOUNTS_REQUEST",
  APPEND_DISCOUNTS_SUCCESS: "APPEND_DISCOUNTS_SUCCESS",

  REMOVE_DISCOUNTS_REQUEST: "REMOVE_DISCOUNTS_REQUEST",
  REMOVE_DISCOUNTS_SUCCESS: "REMOVE_DISCOUNTS_SUCCESS",

  GET_DISCOUNTS_REFERENCES_REQUEST: "GET_DISCOUNTS_REFERENCES_REQUEST",
  GET_DISCOUNTS_REFERENCES_SUCCESS: "GET_DISCOUNTS_REFERENCES_SUCCESS",

  getAllUsersFromMyMenu: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ALL_USERS_FROM_MYMENU_REQUEST,
      });
    };
  },

  getAlLDiscounts: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ALL_DISCOUNTS_REQUEST,
      });
    };
  },

  appendDiscounts: (data) => {
    return (dispatch) => {
      dispatch({
        type: actions.APPEND_DISCOUNTS_REQUEST,
        data,
      });
    };
  },

  removeDiscounts: (data) => {
    return (dispatch) => {
      dispatch({
        type: actions.REMOVE_DISCOUNTS_REQUEST,
        data,
      });
    };
  },

  getDiscountsReferences: (startDate, endDate) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_DISCOUNTS_REFERENCES_REQUEST,
        startDate,
        endDate,
      });
    };
  },
};
export default actions;
